<script lang="ts">
	import type { BadgeColor } from '$lib/components/atoms/badge/types';
	import type { IconName } from '$lib/components/icons/types';
	import type { PoiImages } from '$lib/components/pois/types';
	import defaultPoiImage from '$assets/pois/default.webp';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import PoiImage from '$lib/components/pois/image/PoiImage.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		srcset: PoiImages;
		color?: BadgeColor | undefined;
		icon?: IconName | undefined;
		isHovered?: boolean;
		isSmallImage?: boolean;
		hasShadow?: boolean;
		eager?: boolean;
		isSquare?: boolean;
	}

	const {
		srcset,
		color = undefined,
		icon = undefined,
		isHovered = false,
		isSmallImage = false,
		hasShadow = true,
		eager = false,
		isSquare = false,
	}: Props = $props();

	const imageContainerSizeClasses = isSmallImage ? 'h-20 w-20 aspect-ratio-1' : 'h-30 w-full';
	const imageContainerShadowClasses = hasShadow ? 'shadow' : '';
</script>

<div
	class={['image-container relative rd-2', imageContainerShadowClasses, imageContainerSizeClasses]}
	style="--imageUrl:url({srcset.w320})"
>
	<div class={['image-zoom h-full w-full', isHovered && 'image-zoom-active']}>
		<PoiImage
			{srcset}
			{eager}
			sizes="320px"
			class="image h-full w-full rd-2"
			alt={m.poi_card__image_alt()}
			fallbackSrc={defaultPoiImage}
		/>
	</div>
	{#if icon}
		<div class="absolute top-1 right-1">
			<Badge {icon} {color} {isSquare} />
		</div>
	{/if}
</div>

<style>
	.image-container {
		z-index: 0;
	}

	.image-container.shadow::after {
		content: '';
		background-image: var(--imageUrl);
		background-size: cover;
		background-position: center;
		position: absolute;
		filter: blur(5px);
		width: inherit;
		height: inherit;
		top: 2px;
		left: 0;
		z-index: -1;
		border-radius: inherit;
	}

	.image-zoom {
		transition: transform 0.15s ease-in;
	}

	.image-zoom-active {
		transform: scale(1.008);
		transition: transform 0.2s ease-out;
	}
</style>
